import { UAParser } from 'ua-parser-js'

export type DeviceType = 'mobile' | 'tablet' | 'desktop'

export const getDeviceType = (userAgentString = ''): DeviceType => {
  const parser = new UAParser(userAgentString)
  const deviceType = parser.getDevice().type
  switch (deviceType) {
    case 'mobile':
      return 'mobile'
    case 'tablet':
      return 'tablet'
    case 'desktop':
    default:
      return 'desktop'
  }
}
